import { type ComponentProps, useEffect, useState } from 'react'
import { ListBox, ListBoxItem, Popover } from 'react-aria-components'
import { Button, Label } from '../../primitives'
import Select, { type SelectProps } from '../../primitives/Select'
import SelectValue from '../../primitives/SelectValue'
import { usePopoverWidth } from '~/hooks/usePopoverWidth'
import { ChevronDown700 } from '~/icons'
import { currency } from '~/lib/currency'
import type { Installment } from '~/type/Cart'

type Props = {
  installments?: Installment[]
  containerProps?: ComponentProps<'div'>
  setInstallmentsSelected: (installment: Installment) => void
  popoverWidth?: string
} & SelectProps

const InstallmentsSelect = ({
  installments = [],
  containerProps,
  setInstallmentsSelected,
  ...props
}: Props) => {
  const { popoverWidth, containerRef, updateWidth } = usePopoverWidth()
  const [selectedKey, setSelectedKey] = useState<string | null>(null)

  useEffect(() => {
    if (installments.length <= 0) {
      setInstallmentsSelected({ count: 0, value: 0 })
    }

    if (installments.length > 0) {
      const firstInstallment = installments[0]
      setSelectedKey(String(firstInstallment.count))
      setInstallmentsSelected(firstInstallment)
    }
  }, [installments.length])

  return (
    <div ref={containerRef} {...containerProps}>
      <Select
        className="flex flex-col items-start gap-1 whitespace-pre"
        isDisabled={installments?.length <= 0}
        name="installments"
        placeholder="selecione as parcelas"
        selectedKey={selectedKey}
        onOpenChange={updateWidth}
        onSelectionChange={(key) => {
          const selectedInstallment = installments?.find((installment) => installment.count === Number(key))
          if (selectedInstallment) {
            setInstallmentsSelected(selectedInstallment)
            setSelectedKey(String(key))
          }
        }}
        {...props}
      >
        <Label className="text-gray-100 text-xs">Parcelamento *</Label>
        <Button className="flex  max-h-9 rounded items-center justify-between w-full px-2 text-left border  border-gray-60">
          <SelectValue className="text-center  text-base font-normal text-gray-80 overflow-ellipsis w-11/12 whitespace-nowrap overflow-hidden block" />
          <ChevronDown700 className="fill-gray-100" />
        </Button>
        <Popover>
          <ListBox
            className="overflow-y-scroll lg:w-[261px] bg-white border rounded-md border-gray-60"
            style={{ width: props.popoverWidth ? props.popoverWidth : `${popoverWidth}px` }}
          >
            {installments?.map((installment) => (
              <ListBoxItem
                className="flex items-center justify-between w-full px-4 py-2 text-base font-normal text-primary-black"
                id={String(installment.count)}
                key={installment.count}
                textValue={String(installment.count)}
              >
                {installment.count} de {currency(installment.value)} {installment.count > 1 ? 'vezes' : 'vez'}{' '}
              </ListBoxItem>
            ))}
          </ListBox>
        </Popover>
      </Select>
    </div>
  )
}

export default InstallmentsSelect
